module.exports = __webpack_public_path__ + "static/img/success-icon.e3b28942.png";